// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {routes} from '../shared/routes.js';
import {wrap_cp_url} from '../util.js';
import {Suspense} from '../lazy.js';
import {Switch, createSetComp} from './router_util.js';

const modified_routes = [...routes.cp, ...routes.index]
    .filter(item=>item.template=='light').map(item=>({
    ...item,
    path: wrap_cp_url(item.path),
}));

const setComp = createSetComp(modified_routes);

setComp('/auth*', React.lazy(()=>import('../pages/auth.js')));
setComp('/urls*', React.lazy(()=>import('../pages/urls.js')));
setComp('/restricted', React.lazy(()=>import('../pages/restricted.js')));

export default function Router(){
    return <Suspense page_height>
      <Switch routes={modified_routes}/>
    </Suspense>;
}
